import React from 'react'
import EfficiencyLinearProgressItem from './subcomponents/efficiencyLinearProgressItem.tsx';
const EfficiencySummaryReport = () => {
    return (
        <>
            <div className="text-graph">
                <h6 className="text-center mb-2 text-light"><b>Efficiency</b></h6>
                <h6 className="ms-0 text-light">Machinical</h6>
                <div className="">
                    <div className="p-0 m-0">
                        <EfficiencyLinearProgressItem
                            title="Chiller Plant"
                            color="rgba(176, 253, 253, 0.459)"
                            progress="100"
                            value="13.2" />
                        {/*  */}
                        <EfficiencyLinearProgressItem
                            title="Air Conditioning System"
                            color="#476ca386"
                            progress="35"
                            value="2.5" />
                        <EfficiencyLinearProgressItem
                            title="Cooling Systems"
                            color="rgba(176, 253, 253, 0.459)"
                            progress="50"
                            value="6.5" />
                        <EfficiencyLinearProgressItem
                            title="Air Distribution System"
                            color="#476ca386"
                            progress="60"
                            value="8.5" />
                        <EfficiencyLinearProgressItem
                            title="Fire Protection Systems"
                            color="#476ca386"
                            progress="30"
                            value="8.5" />
                        <EfficiencyLinearProgressItem
                            title="Sanitary System"
                            color="rgba(176, 253, 253, 0.459)"
                            progress="89"
                            value="7.5" />
                    </div>
                </div>
                <h6 className="mt-2 ms-0 text-light">Electrical</h6>
                <div className="" id="main">
                    <div className="row p-0 m-0">
                        {/*  */}
                        <EfficiencyLinearProgressItem
                            title="Lighting System"
                            color="rgba(176, 253, 253, 0.459)"
                            progress="89"
                            value="9" />

                        {/*  */}
                        <EfficiencyLinearProgressItem
                            title="Power Distribution System"
                            color="#476ca386"
                            progress="39"
                            value="7.4" />
                        <EfficiencyLinearProgressItem
                            title="Extra Low Voltage (ELV) System"
                            color="rgba(176, 253, 253, 0.459)"
                            progress="89"
                            value="7.4" />
                        <EfficiencyLinearProgressItem
                            title="Lightning Protection System"
                            color="rgba(176, 253, 253, 0.459)"
                            progress="59"
                            value="7.4" />
                        <EfficiencyLinearProgressItem
                            title="Vertical Transportation System"
                            color="#476ca386"
                            progress="39"
                            value="7.4" />
                    </div>
                </div>
                <h6 className="mt-2 ms-0 text-light">Landscape</h6>
                <div>
                    <div className="p-0 m-0">
                        <EfficiencyLinearProgressItem
                            title="Softcape"
                            color="rgba(176, 253, 253, 0.459)"
                            progress="39"
                            value="7.4" />
                        {/*  */}
                        <EfficiencyLinearProgressItem
                            title="Hardscape"
                            color="#476ca386"
                            progress="39"
                            value="7.4" />

                        {/*  */}
                        <EfficiencyLinearProgressItem
                            title="Roof, Sky Terraces, Edge/Facade"
                            color="#476ca386"
                            progress="39"
                            value="7.4" />
                        <EfficiencyLinearProgressItem
                            title="Standalones Structure"
                            color="#476ca386"
                            progress="100"
                            value="7.4" />
                    </div>
                </div>
                <h6 className="mt-2 ms-0 text-light">Smart Solutions</h6>
                <div className="">
                    <div className="p-0 m-0">
                        <EfficiencyLinearProgressItem
                            title="Cybersecurity"
                            color="rgba(176, 253, 253, 0.459)"
                            progress="59"
                            value="4" />

                        {/*  */}
                        <EfficiencyLinearProgressItem
                            title="Adpotive Solution"
                            color="rgba(176, 253, 253, 0.459)"
                            progress="100"
                            value="7.4" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default EfficiencySummaryReport;